import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 250,
	height: 250,
	fill: "none",
	viewBox: "0 0 247 250",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#Checkmark-a27b6d_a)",
			d: "M174.912 52.57c-39.909-27.688-94.69-17.754-122.355 22.19-21.688 31.314-20.274 71.773.575 101.136l.162-.115c27.965 39.736 82.817 49.259 122.518 21.272 19.894-14.024 32.209-34.807 36.027-57.053h6.977c-3.881 24.424-17.24 47.313-39.038 62.68-33.562 23.659-77.165 22.458-108.966.193l-.007.008c-43.034-29.855-53.736-88.972-23.907-132.04 29.83-43.07 88.901-53.785 131.938-23.928z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#Checkmark-a27b6d_b)",
			fillRule: "evenodd",
			d: "m204.43 78.05-81.826 79.931a3.44 3.44 0 0 1-4.811 0l-31.53-30.801 4.81-4.924 29.126 28.452 79.42-77.582z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "Checkmark-a27b6d_a",
			x1: 211.5,
			x2: 168.162,
			y1: 142,
			y2: 149.425,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "var(--chakra-colors-illustration-fg)",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-fg)"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "Checkmark-a27b6d_b",
			x1: 151.043,
			x2: 201.355,
			y1: 132.085,
			y2: 80.58,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--chakra-colors-illustration-accent)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--chakra-colors-illustration-accent)",
				stopOpacity: 0
			})]
		})] })
	]
});
export default SvgCheckmark;
